import { setContext } from '@apollo/client/link/context';
import { connectApolloClientToVSCodeDevTools } from '@apollo/client-devtools-vscode';
import {
  authUtil,
  configUtil
} from 'modules/common/layer00';

import * as cache from './cache';

import {
  ApolloClient,
  createHttpLink,
  from,
  split
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';


import { GraphQLWsLink } from '@apollo/client/link/subscriptions';

import { isLoggedInVar } from 'modules/common/layer00/reactiveVariables';

import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { DateTime } from 'luxon';
import _ from 'lodash';

const { envName, ignoreAccessToken } = configUtil.getConfig();



const httpAuthLink = setContext(async ({ context }) => {
  let accessToken: string | null;
  if (envName === 'devLocal' && ignoreAccessToken) {
    accessToken = 'BY-PASSED';
    console.log(accessToken);
    if (accessToken) {
      return {
        headers: {
          ...context?.headers
        }
      };
    }

  } else {
    accessToken = await authUtil.getAccessToken(); // Always returns a good access token if logged in.
  }
  if (envName !== 'prod') {
    console.log(`Bearer ${accessToken}`);
  }
  if (accessToken) {
    return {
      headers: {
        ...context?.headers,
        authorization: `Bearer ${accessToken}`
      }
    };
  }

  return {
    headers: {
      ...context?.headers
    }
  };
});



const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_GRAPHQL_URL
});

const authHttpLink = from([
  httpAuthLink,
  httpLink
]);



const wsLink = __makeWsLink();


function __makeWsLink() {
  const url = process.env.REACT_APP_API_WS_URL;
  const client = createClient({
    url: url ?? '',
    keepAlive: 10_000,
    connectionParams: async () => {
      const accessToken = await authUtil.getAccessToken();
      if (!ignoreAccessToken) {
        return {
        };
      }
      if (accessToken) {
        return {
          Authorization: `Bearer ${accessToken}`
        };
      }
      return {
      };
    }
  });
  return new GraphQLWsLink(client);
}

const errorLink = onError(({
  graphQLErrors, networkError
}) => {
  const newMessages = [];
  if (graphQLErrors) {
    const m = graphQLErrors.map((e) => ({
      type: 'error',
      timestamp: DateTime.now(),
      message: e.message
    }));
    newMessages.push(...m);
  }

  if (networkError) {
    newMessages.push({
      type: 'error',
      timestamp: DateTime.now(),
      message: networkError.message
    });
  }

  if (!_.isEmpty(newMessages)) {
    throw new Error(`${newMessages.map((n) => {
      return `${n.type}: ${n.message}`;
    }).join('\n')}`);
  }
});



const __makeClient = () => {
  if (envName !== 'dev' && envName !== 'prod') {
    console.log('Creating New apollo client');
  }
  const wsLink = __makeWsLink();
  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === 'OperationDefinition'
          && definition.operation === 'subscription'
      );
    },
    wsLink,
    from([
      httpAuthLink,
      httpLink
    ])
  );


  return new ApolloClient({
    link: from([
      errorLink,
      splitLink
    ]),
    connectToDevTools: true,
    cache: cache.init()
  });
};


export const client = __makeClient();

if (envName !== 'dev' && envName !== 'prod' && envName !== 'edge') {
  connectApolloClientToVSCodeDevTools(
    client,
    'ws://localhost:7095'
  );
}



authUtil.subjChangeAuthStatus.subscribe((value) => {
  if (!value) {
    client.cache.evict({
    });
    client.cache.reset();
  }
  isLoggedInVar(value);
});



